import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import { getContentBlockItemsByName } from '../../../Cms/CmsActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import PredictiveLink from '../../../Cms/components/view/PredictiveLink.js';

function PanelFooterLinks({ location, navigate, panel }) {
    const needObfuscate = false && (location.pathname || '').split('/').filter(part => part).length > 1;

    const handleGoTo = event => navigate(event.target.getAttribute('data-path'));

    return (
        <div>
            {getContentBlockItemsByName(panel.blocks, 'links').map((link, index) => (
                <div className="d-inline pt-2 me-2" key={link.path}>
                    {link.needObfuscate || needObfuscate ? <span className="p-0 text-start text-black-50" style={{ cursor: 'pointer' }} data-path={link.path} onClick={handleGoTo}>{link.text}</span> : <Link to={link.path} target={/http(s)?:\/\//.test(link.path) ? '_blank' : ''} className="p-0 text-black-50">{link.text}</Link>}
                </div>
            ))}
        </div>
    );
}

PanelFooterLinks.propTypes = {
    location: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    panel: PropTypes.object.isRequired,
};

export default withRouter(PanelFooterLinks, ['navigate', 'location']);
